import React, { Component } from 'react';
import { Button, Stack, TextField } from '@envoy/polarwind';
import Select from './components/Select';

class ChoiceColumnMapping extends Component {

  onRemove = () => {
    const { index, mapping, mappingIndex } = this.props;
    const { choiceMappings = [] } = mapping;

    this.props.onChangeFieldMapping({
        ...mapping,
        choiceMappings: (choiceMappings || []).filter((m, i) => i !== index),
      },
      mappingIndex,
    );
  };

  onChangeEnvoyValue = envoyValue => {
    const { index, mapping, mappingIndex, serviceNowValue } = this.props;
    const { choiceMappings = {} } = mapping;

    this.props.onChangeFieldMapping({
        ...mapping,
        choiceMappings: (choiceMappings || []).map((m ,i) => i === index ? ({ envoyValue, serviceNowValue }) : m),
      },
      mappingIndex,
    );
  };

  onChangeServiceNowValue = serviceNowValue => {
    const { index, mapping, mappingIndex, envoyValue } = this.props;
    const { choiceMappings = {} } = mapping;

    this.props.onChangeFieldMapping({
        ...mapping,
        choiceMappings: (choiceMappings || []).map((m ,i) => i === index ? ({ envoyValue, serviceNowValue }) : m),
      },
      mappingIndex,
    );
  };

  render() {
    const { index, envoyValue, serviceNowValue, choiceOptions } = this.props;
    return (
      <Stack style={{marginTop: 0}}>
        <div style={{textAlign: 'right', paddingTop: 23}}>
          <Button onClick={this.onRemove} plain>x</Button>
        </div>
        <div style={{minWidth: 200}}>
          <TextField
            key={`input-for-${index}`}
            label="Envoy value"
            value={envoyValue}
            onChange={this.onChangeEnvoyValue}
          />
        </div>
        <div style={{minWidth: 200}}>
          <Select
            label="ServiceNow value"
            options={choiceOptions}
            value={serviceNowValue}
            isLoading={!choiceOptions}
            onChange={this.onChangeServiceNowValue}
            required
          />
        </div>
      </Stack>
    );
  }
}

export default ChoiceColumnMapping;
